const API_BASE = '/api';

interface EsqueciSenhaResponse {
  status: number;
  tipo?: 'enviado' | 'login_social' | 'nao_encontrado';
  mensagem?: string;
}

/**
 * Solicita redefinição de senha via POST /api/senha/esqueci.
 * Retorna o tipo de resultado e mensagem para exibição ao usuário.
 */
export async function esqueciSenha(email: string): Promise<EsqueciSenhaResponse> {
  const res = await fetch(`${API_BASE}/senha/esqueci`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });

  if (res.ok) {
    const data = await res.json();
    return { status: res.status, tipo: data.tipo, mensagem: data.mensagem };
  }

  return { status: res.status };
}

/**
 * Troca a senha obrigatória (primeiro login com senha provisória).
 * POST /api/auth/trocar-senha
 */
export async function trocarSenha(novaSenha: string): Promise<void> {
  const token = localStorage.getItem('auth_token');
  const res = await fetch(`${API_BASE}/auth/trocar-senha`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ novaSenha }),
  });

  if (!res.ok) {
    const data = await res.json();
    throw new Error(data.error?.message || 'Erro ao trocar a senha.');
  }
}


interface ValidarTokenResponse {
  valido: boolean;
  mensagem?: string;
}

/**
 * Valida se um token de redefinição de senha é válido e não expirado.
 * GET /api/senha/validar-token/:token
 */
export async function validarToken(token: string): Promise<ValidarTokenResponse> {
  try {
    const res = await fetch(`${API_BASE}/senha/validar-token/${encodeURIComponent(token)}`);
    const data = await res.json();

    if (!res.ok) {
      return { valido: false, mensagem: data.error?.message || 'Token inválido ou expirado.' };
    }

    return { valido: true };
  } catch {
    return { valido: false, mensagem: 'Erro de conexão. Tente novamente.' };
  }
}

interface RedefinirSenhaResponse {
  sucesso: boolean;
  mensagem?: string;
}

/**
 * Redefine a senha usando um token válido.
 * POST /api/senha/redefinir
 */
export async function redefinirSenha(
  token: string,
  novaSenha: string,
): Promise<RedefinirSenhaResponse> {
  try {
    const res = await fetch(`${API_BASE}/senha/redefinir`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, novaSenha }),
    });

    if (!res.ok) {
      const data = await res.json();
      return { sucesso: false, mensagem: data.error?.message || 'Erro ao redefinir senha.' };
    }

    return { sucesso: true };
  } catch {
    return { sucesso: false, mensagem: 'Erro de conexão. Tente novamente.' };
  }
}
